import Modal from '../../common/Modal'
import PropTypes from 'prop-types'
import { useState } from 'react'

import SubmitButton from '../../common/buttons/SubmitButton'
import Input from '../../common/form/Input'
import { ReactComponent as WarningIcon } from '../../../assets/images/common/icons/warning-icon.svg'

import styles from './MoveFromWaitlistModal.module.scss'
import classNames from 'classnames'

const MoveFromWaitlistModal = ({ showModal, closeModal, onSubmit, event, status }) => {
  const [coachNote, setCoachNote] = useState(null)


  const handleInputChange = e => {
    setCoachNote(e.target.value)
  }

  return (
    <Modal
      isOpen={showModal}
      onClose={closeModal}
      className={styles.moveFromWaitlistModal}
      autoFocus
    >
      <div className={classNames('d-flex flex-column align-items-center', styles.modalContainer)}>
        <div className='d-flex justify-content-center align-items-center'>
          <WarningIcon/>
        </div>
        <div className={styles.modalContent}>
          <p className={styles.title}>{`Mark as ${status}`}</p>
          <p className={styles.message}>
            {status === 'Attending'
              ? 'This will move the student from the waitlist and mark them as Attending for this event.\
              \n\nThey will be added to the event and included in pairings.'
              : 'This will remove the student from the waitlist and mark them as Not Attending.\
              \n\nThey will not be added to the event or included in pairings.'
            }
          </p>

          {status === 'Attending' && event.capacityReached &&
            <p className='mb-3'>{`Event capacity will increase to ${ event.spotsAvailable + 1 } to accommodate this player.`}</p>
          }

          <span>Optional message for the family</span>
          <div className='mt-2 mb-3'>


            <Input
              name='note'
              type='textarea'
              onChange={handleInputChange}
              value={coachNote}
              styles={{ inputContainer: { height: '90px' } }}
            />
          </div>

          <span>The family will be notified of this update.</span>
        </div>
        <div className='w-100 pull-bottom mt-3'>
          <SubmitButton
            onClick={() => onSubmit(status, coachNote)}
            buttonMessage={`Mark as ${status}`}
            buttonColor='orange-button'
          />
          <SubmitButton
            onClick={closeModal}
            buttonMessage='Cancel'
            buttonColor='navy-button'
          />
        </div>
      </div>
    </Modal>
  )
}

MoveFromWaitlistModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  event: PropTypes.shape({
    spotsAvailable: PropTypes.number.isRequired,
    capacityReached: PropTypes.bool,
  }),
  status: PropTypes.string,
}

export default MoveFromWaitlistModal
